<template>
  <div class="toggle-buttons">
    <button
      v-for="option in options"
      :key="option.value"
      class="button button-small button-round"
      :class="{
        'button-binity-blue': option.value === value,
        'button-binity-blue--outline': option.value !== value,
      }"
      @click="$emit('input', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      // [{ label: 'xxx', value: 'xxx' }, ...]
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      required: false,
    },
  },
}
</script>

<style scoped lang="scss">
.toggle-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;

  &.full-width > * {
    flex: 1;
  }
}
</style>
